export const SAVE_ALL_TOLLS = 'SAVE_ALL_TOLLS'